var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kw_change_look"},[_c('span',{on:{"click":_vm.openChangeDialog}},[_vm._v("\n      "+_vm._s(_vm.initData.fieldCnName)+":"+_vm._s(_vm.initData.defaultValStr)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }